export default __webpack_public_path__ + "static/media/2.14e99023.jpg";